import { useSpring } from '@react-spring/web'
import { useDrag } from '@use-gesture/react'
import { IS_IOS } from '$func/environmentInfo'
import { RefObject } from 'react'

const VELOCITY_LIMITS = IS_IOS
  ? {
      afterMinimumDrag: 0.02,
      beforeMinimumDrag: 0.3,
    }
  : {
      afterMinimumDrag: 0.05,
      beforeMinimumDrag: 0.7,
    }

interface Props {
  onClose: () => unknown
  enabled: boolean
  isSliderMovingRef?: RefObject<boolean>
}

export function useStoryDragController({
  onClose,
  enabled,
  isSliderMovingRef,
}: Props) {
  const [{ y: offsetY }, api] = useSpring(() => ({ y: 0 }))

  const bindGestureEvents = useDrag(
    ({
      movement: [, my],
      velocity: [, vy],
      down,
      direction: [, dy],
      cancel,
    }) => {
      if (isSliderMovingRef?.current) {
        api.start({
          y: 0,
        })
        cancel()
        return
      }
      if (
        ((Math.abs(my) > window.innerHeight / 4 &&
          vy > VELOCITY_LIMITS.afterMinimumDrag) ||
          vy > VELOCITY_LIMITS.beforeMinimumDrag) &&
        dy >= 0 &&
        !down
      ) {
        onClose()
      }
      api.start({
        y: down ? Math.max(my, 0) : 0,
      })
    },
    { enabled: enabled },
  )

  return { offsetY, bindGestureEvents }
}
